module.exports = {
  games: {
    answer_submission_error: 'Answer could not be transmitted. Please choose new.',
    audio_no_browser_support: 'Your browser does not support the audio element.',
    challenge_bot: 'Challenge a Bot',
    bot_difficulty_1: 'Beginner',
    bot_difficulty_2: 'Advanced',
    choose_category: 'Choose Category',
    choose_random_opponent: 'Challenge a random player',
    next_round: 'Next Round:',
    opponent_reached_max_game_limit: 'You already have an active game with this user. Choose another player. | Limit of simultaneous games ({count} games) with this user reached. Choose another player.',
    submit_answer: 'Submit answer',
    your_turn: 'Your Turn',
    time_has_passed: 'The time has expired',
    game_status_aborted_short: 'Cancelled',
    round_n: 'Round %{n}',
    xes_turn: '%{username} is up',
    your_turn_emoji: "👉 It's your turn!",
    you_lost_emoji: 'You lost this battle! 🙈',
    challenge_revenge: 'Take revenge by challenging your opponent',
    draw_emoji: 'This battle ended in a draw ⚖️',
    challenge_again: 'Challenge again',
    rematch: 'Rematch',
    you_won_emoji: 'You won this battle! 🎉',
    your_active_battles: 'Your active quiz battles',
    show_finished_battles: 'View completed quiz battles',
    draw_short: 'Undecided',
    win_short: 'You won!',
    lost_short: 'You lost.',
    your_time_left: 'You still have %{hours} hrs %{minutes} min %{seconds} sec to answer.',
    opponents_turn_emoji: '⏳ %{opponentName} is up',
    opponents_time_left: 'And still has %{hours}hrs %{minutes}min to answer.',
    startet_at: 'Started on %{date} at %{time}',
    quiz_history: 'Quiz History',
    quiz_stats: 'Quiz-Statistics',
    game_status_my_turn: "It's your turn",
    game_status_you_won: 'You won',
    game_status_you_lost: 'You lost',
    game_status_draw: "It's a draw",
    game_status_opponent_turn: "It's %{opponentName}'s turn",
    game_status_canceled: 'Game was cancelled',
    begin_quiz: 'Begin quiz',
    play_quiz: 'Play quiz',
    card_timestamp_format: '%{date} %{time}',
  },
  quizteams: {
    add_new_member: 'Add a new member',
    create_description: 'Give your team a name. Then you can add team members.',
    create_new_quizteam: 'Create new quiz team',
    teamname: 'Team name',
    create_quizteam: 'Create team',
    at_least_3_characters: 'Please enter at least 3 letters as the team name.',
    team_details: 'Team details',
    create_new: 'Create a new quiz team',
    all: 'All teams',
    mine: 'My teams',
    quizteams: 'Teams',
    add_new_member_description: 'Start typing a username to add a new member.',
    add_member_to_team: 'Add to team',
    your_teams: 'Your quiz teams',
    no_teams_yet: "You haven't joined a team yet. Ask the admin of another team to take you on or create your own team and invite others.",
    show_my_teams: 'View my quiz teams',
    members: 'Members',
    add_member: 'Add member',
    admin: 'Admin',
  },
  questions: {
    suggest_new_question: 'Submit your own question',
    question: 'Question',
    question_n: 'Question %{n}',
    suggest_questions: 'Suggest quiz questions',
    your_notes: 'Your notes',
  },
  statistics: {
    all_tags: 'All Tags',
    games_won: 'Games won',
    questions_correct: 'Correct answers',
    top_quiz_teams: 'Top quiz teams',
    top_players: 'Top players',
    my_statistics: 'My statistics',
    show_all: 'To all statistics',
    show_all_players: 'View all players',
    show_all_teams: 'View all teams',
    questions_correct_percentage: 'Percentage',
    win_quote: 'Win %',
  },
  no_categories: 'You do not have any playable categories available. Please contact your administrator.',
  no_categories_mail: 'You do not have any playable categories available. Please contact your administrator: %{adminMail}',
  answered_correctly: 'Correct!',
  answered_incorrectly: "Sorry, that's not correct.",
  feedback: 'Resolution',
  joker: '50:50 joker 🔮',
  joker_used: '50:50 joker used',
  next_question: 'Next question',
  start_first_quiz: 'Start your first quiz now:',
  start_new_quiz: 'Start a new quiz battle',
  your_turn_choose_category: "You're up. Select a category:",
  search_opponent: 'search opponents',
  challenge: 'Challenge',
  new_random_opponent: 'New proposal',
  quiz_battle: 'Quiz battle',
  vs: 'vs',
  start_quiz: 'Begin quiz',
  start_round: "Let's battle it out!",
  category_competition_label: 'Competition 🏆',
}
